/* eslint-disable no-undef */
/* eslint-disable lines-between-class-members */
/* eslint-disable curly */
/* eslint-disable prefer-const */
import { observable, action } from 'mobx';
// import { Utils } from 'Utils/utils';
// import * as CONSTANTS from 'Utils/constants';
import { makeApi, URLS } from 'Utils/apiUtil';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import userDetail from 'Stores/userDetail';
import { confirmationPopupState } from '../components/common/confirmationPopup';

let cancelCalculatePricingCall = null;
class PricingDataState {
  @observable showPaymentForm = false;

  @observable showPaymentSuccessPopup = false;

  @observable showPaymentReviewPopup = false;

  @observable isAnnualSelected = true;

  @observable selectedPlan = null;

  @observable isPriceCalculationLoading = false;

  @action
  setShowPaymentSuccessPopup = (value = false) => {
    this.showPaymentSuccessPopup = value;
  };

  @action
  setShowPaymentReviewPopup = (value = false) => {
    this.showPaymentReviewPopup = value;
  };

  @action
  setShowPaymentForm = (value = false) => {
    this.showPaymentForm = value;
    if (value)
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
    else
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
  };

  @action
  setSelectedPlan = value => {
    this.selectedPlan = value;
  };

  @action
  setAnnualSelected = (value = false) => {
    this.isAnnualSelected = value;
  };

  @action
  freemiumPlanRequest = async (
    selectedPlan,
    isAnnualSelected,
    callback = () => {},
  ) => {
    try {
      const thisObj = this;
      const {
        id: selectedPlanId,
        name: selectedPlanName,
        price,
      } = selectedPlan;

      const purchaseUrl = URLS.planSubscribe;
      const config = {
        url: `${purchaseUrl}?selectedPlanId=${selectedPlanId}&annual=${isAnnualSelected}`,
        method: 'POST',
        data: {},
      };

      Utils.mixpanelTrack(
        CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_PURCHASE_PLAN,
        {
          isAnnual: isAnnualSelected,
          selectedPlanType: selectedPlanName,
        },
      );
      let res = await makeApi(config, false);
      callback(res);
    } catch (err) {
      console.error(err, 'freemiumPlanRequest');
    }
  };

  @action
  paymentSubmit = async (inputData, tokenObj, callback = () => {}) => {
    try {
      const thisObj = this;
      const { phone } = inputData;
      const { selectedPlan, isAnnualSelected } = thisObj;
      const {
        id: selectedPlanId,
        name: selectedPlanName,
        price,
      } = selectedPlan;
      const { id: token } = tokenObj;

      const isDirectPurchaseEnabled = true;
      const purchaseUrl = URLS.planSubscribe;

      const config = {
        url: `${purchaseUrl}?selectedPlanId=${selectedPlanId}&annual=${isAnnualSelected}&phone=${phone}&stripeToken=${token}`,
        method: 'POST',
        data: {},
      };

      Utils.mixpanelTrack(
        CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_PURCHASE_PLAN,
        {
          isAnnual: isAnnualSelected,
          phoneNumber: phone,
          selectedPlanType: selectedPlanName,
        },
      );
      let res = await makeApi(config, false);

      if (
        res &&
        res.data &&
        Object.keys(res.data).length > 0 &&
        res.data.status === 'true'
      ) {
        Utils.mixpanelTrack(
          CONSTANTS.MX_PRICING_PAGE.LB_PRICING_PAYMENT_SUCCESS,
          {
            isAnnual: isAnnualSelected,
            phoneNumber: phone,
            selectedPlanType: selectedPlanName,
          },
        );
        thisObj.showPaymentForm = false;
        if (isDirectPurchaseEnabled) {
          thisObj.setShowPaymentSuccessPopup(true);
        } else {
          thisObj.setShowPaymentReviewPopup(true);
        }
      } else {
        let { message } = res.data;
        if (message === null || message === undefined) {
          message = 'Your payment has failed';
        }
        Utils.mixpanelTrack(
          CONSTANTS.MX_PRICING_PAGE.LB_PRICING_PAYMENT_FAILED,
          {
            isAnnual: isAnnualSelected,
            phoneNumber: phone,
            selectedPlanType: selectedPlanName,
            paymentFailedReason: message,
          },
        );
        callback(message);
      }
    } catch (err) {
      console.error(err, 'payment submit');
    }
  };
}

const pricingDataState = new PricingDataState();
export { pricingDataState, PricingDataState };
export default pricingDataState;
